import React, { useCallback } from 'react';
import { Page } from '../page/page';
import { withRouter } from 'react-router-dom';
import { createRefetchContainer, graphql } from 'react-relay';
import RaisedButton from 'material-ui/RaisedButton';
import VocabularyListItem from './vocabulary-list-item';
import { DataGrid } from '../ui/data-grid/data-grid';

const VocabularyList = props => {
	const { history, viewer } = props;

	const edges = viewer.vocabulary.edges;

	const handleClick = useCallback(() => {
		history.push('/vocabulary/add');
	}, [history]);

	const onRowClick = useCallback(id => {
		history.push(`/vocabulary/${id}`);
	}, []);

	const columns = [
		{ title: 'Имя', width: '25%' },
		{ title: 'Значение', width: '25%' },
		{ title: 'Описание', width: '35%' },
		{ title: 'Можно удалить', width: '15%' }
	];

	return (
		<Page title="Справочник">
			<RaisedButton label="Добавить элемент справочника" primary={true} onClick={handleClick} />
			<DataGrid columns={columns} items={edges}>
				{edges.map(({ node }) => (
					<VocabularyListItem key={node.id} item={node} viewer={viewer} handleClick={onRowClick} />
				))}
			</DataGrid>
		</Page>
	);
};

export default withRouter(
	createRefetchContainer(
		VocabularyList,
		graphql`
			fragment vocabularyList_viewer on Viewer {
				vocabulary {
					edges {
						node {
							...vocabularyListItem_item
						}
					}
				}
			}
		`,
		graphql`
			query vocabularyListRefetch_Query {
				viewer {
					...vocabularyList_viewer
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/vocabulary/vocabulary-list.js